import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { apiService } from '@services/api';
import { AuthStatusAnnouncer } from '../auth/AuthStatusAnnouncer';

const AuthWrapper = styled.main`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 2rem 1rem;
  background: var(--surface-strong);
  @media (max-width: 767px) {
    align-items: start;
  }
`;
const AuthCard = styled.section`
  width: 100%;
  max-width: 440px;
  padding: 2rem;
  border-radius: var(--radius-xl);
  background: var(--surface);
  border: 1px solid var(--border);
  @media (max-width: 767px) {
    padding: 1.5rem;
  }
`;
const Brand = styled.div`
  margin-bottom: 1.5rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid var(--border);
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.035em;
  span {
    margin-left: 0.5rem;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0;
    color: var(--text-muted);
  }
`;
export const AuthLayout: React.FC = () => {
  React.useEffect(() => {
    void apiService.initialize();
  }, []);
  return (
    <AuthWrapper>
      <AuthCard>
        <Brand>
          Foodprint<span>by Baseline</span>
        </Brand>
        <Outlet />
      </AuthCard>
      <AuthStatusAnnouncer />
    </AuthWrapper>
  );
};
